import { __assign, __extends } from "tslib";
import { CloudWatchServiceException as __BaseException } from "./CloudWatchServiceException";
export var ActionsSuppressedBy;
(function (ActionsSuppressedBy) {
    ActionsSuppressedBy["Alarm"] = "Alarm";
    ActionsSuppressedBy["ExtensionPeriod"] = "ExtensionPeriod";
    ActionsSuppressedBy["WaitPeriod"] = "WaitPeriod";
})(ActionsSuppressedBy || (ActionsSuppressedBy = {}));
export var AnomalyDetectorType;
(function (AnomalyDetectorType) {
    AnomalyDetectorType["METRIC_MATH"] = "METRIC_MATH";
    AnomalyDetectorType["SINGLE_METRIC"] = "SINGLE_METRIC";
})(AnomalyDetectorType || (AnomalyDetectorType = {}));
var ConcurrentModificationException = (function (_super) {
    __extends(ConcurrentModificationException, _super);
    function ConcurrentModificationException(opts) {
        var _this = _super.call(this, __assign({ name: "ConcurrentModificationException", $fault: "client" }, opts)) || this;
        _this.name = "ConcurrentModificationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConcurrentModificationException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConcurrentModificationException;
}(__BaseException));
export { ConcurrentModificationException };
var DashboardInvalidInputError = (function (_super) {
    __extends(DashboardInvalidInputError, _super);
    function DashboardInvalidInputError(opts) {
        var _this = _super.call(this, __assign({ name: "DashboardInvalidInputError", $fault: "client" }, opts)) || this;
        _this.name = "DashboardInvalidInputError";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DashboardInvalidInputError.prototype);
        _this.dashboardValidationMessages = opts.dashboardValidationMessages;
        return _this;
    }
    return DashboardInvalidInputError;
}(__BaseException));
export { DashboardInvalidInputError };
var DashboardNotFoundError = (function (_super) {
    __extends(DashboardNotFoundError, _super);
    function DashboardNotFoundError(opts) {
        var _this = _super.call(this, __assign({ name: "DashboardNotFoundError", $fault: "client" }, opts)) || this;
        _this.name = "DashboardNotFoundError";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DashboardNotFoundError.prototype);
        return _this;
    }
    return DashboardNotFoundError;
}(__BaseException));
export { DashboardNotFoundError };
var ResourceNotFound = (function (_super) {
    __extends(ResourceNotFound, _super);
    function ResourceNotFound(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFound", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFound";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFound.prototype);
        return _this;
    }
    return ResourceNotFound;
}(__BaseException));
export { ResourceNotFound };
var InternalServiceFault = (function (_super) {
    __extends(InternalServiceFault, _super);
    function InternalServiceFault(opts) {
        var _this = _super.call(this, __assign({ name: "InternalServiceFault", $fault: "server" }, opts)) || this;
        _this.name = "InternalServiceFault";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalServiceFault.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InternalServiceFault;
}(__BaseException));
export { InternalServiceFault };
var InvalidParameterCombinationException = (function (_super) {
    __extends(InvalidParameterCombinationException, _super);
    function InvalidParameterCombinationException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterCombinationException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterCombinationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterCombinationException.prototype);
        return _this;
    }
    return InvalidParameterCombinationException;
}(__BaseException));
export { InvalidParameterCombinationException };
var InvalidParameterValueException = (function (_super) {
    __extends(InvalidParameterValueException, _super);
    function InvalidParameterValueException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterValueException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterValueException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterValueException.prototype);
        return _this;
    }
    return InvalidParameterValueException;
}(__BaseException));
export { InvalidParameterValueException };
var MissingRequiredParameterException = (function (_super) {
    __extends(MissingRequiredParameterException, _super);
    function MissingRequiredParameterException(opts) {
        var _this = _super.call(this, __assign({ name: "MissingRequiredParameterException", $fault: "client" }, opts)) || this;
        _this.name = "MissingRequiredParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MissingRequiredParameterException.prototype);
        return _this;
    }
    return MissingRequiredParameterException;
}(__BaseException));
export { MissingRequiredParameterException };
var ResourceNotFoundException = (function (_super) {
    __extends(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        _this.ResourceType = opts.ResourceType;
        _this.ResourceId = opts.ResourceId;
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNotFoundException;
}(__BaseException));
export { ResourceNotFoundException };
export var ScanBy;
(function (ScanBy) {
    ScanBy["TIMESTAMP_ASCENDING"] = "TimestampAscending";
    ScanBy["TIMESTAMP_DESCENDING"] = "TimestampDescending";
})(ScanBy || (ScanBy = {}));
var InvalidNextToken = (function (_super) {
    __extends(InvalidNextToken, _super);
    function InvalidNextToken(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidNextToken", $fault: "client" }, opts)) || this;
        _this.name = "InvalidNextToken";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidNextToken.prototype);
        return _this;
    }
    return InvalidNextToken;
}(__BaseException));
export { InvalidNextToken };
var LimitExceededException = (function (_super) {
    __extends(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "LimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return LimitExceededException;
}(__BaseException));
export { LimitExceededException };
export var StatusCode;
(function (StatusCode) {
    StatusCode["COMPLETE"] = "Complete";
    StatusCode["INTERNAL_ERROR"] = "InternalError";
    StatusCode["PARTIAL_DATA"] = "PartialData";
})(StatusCode || (StatusCode = {}));
export var MetricStreamOutputFormat;
(function (MetricStreamOutputFormat) {
    MetricStreamOutputFormat["JSON"] = "json";
    MetricStreamOutputFormat["OPEN_TELEMETRY_0_7"] = "opentelemetry0.7";
})(MetricStreamOutputFormat || (MetricStreamOutputFormat = {}));
export var RecentlyActive;
(function (RecentlyActive) {
    RecentlyActive["PT3H"] = "PT3H";
})(RecentlyActive || (RecentlyActive = {}));
var LimitExceededFault = (function (_super) {
    __extends(LimitExceededFault, _super);
    function LimitExceededFault(opts) {
        var _this = _super.call(this, __assign({ name: "LimitExceededFault", $fault: "client" }, opts)) || this;
        _this.name = "LimitExceededFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededFault.prototype);
        return _this;
    }
    return LimitExceededFault;
}(__BaseException));
export { LimitExceededFault };
var InvalidFormatFault = (function (_super) {
    __extends(InvalidFormatFault, _super);
    function InvalidFormatFault(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidFormatFault", $fault: "client" }, opts)) || this;
        _this.name = "InvalidFormatFault";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidFormatFault.prototype);
        return _this;
    }
    return InvalidFormatFault;
}(__BaseException));
export { InvalidFormatFault };
export var AlarmHistoryItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RangeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AnomalyDetectorConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DimensionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricStatFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricDataQueryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricMathAnomalyDetectorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SingleMetricAnomalyDetectorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var AnomalyDetectorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartialFailureFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CompositeAlarmFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DashboardEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DashboardValidationMessageFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatapointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteAlarmsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteAnomalyDetectorInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteAnomalyDetectorOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDashboardsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDashboardsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteInsightRulesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteInsightRulesOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteMetricStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteMetricStreamOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAlarmHistoryInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAlarmHistoryOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAlarmsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricAlarmFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAlarmsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAlarmsForMetricInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAlarmsForMetricOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAnomalyDetectorsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeAnomalyDetectorsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeInsightRulesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InsightRuleFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DescribeInsightRulesOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DimensionFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DisableAlarmActionsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DisableInsightRulesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DisableInsightRulesOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnableAlarmActionsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnableInsightRulesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EnableInsightRulesOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDashboardInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDashboardOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetInsightRuleReportInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InsightRuleContributorDatapointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InsightRuleContributorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var InsightRuleMetricDatapointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetInsightRuleReportOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LabelOptionsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricDataInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MessageDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricDataResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricDataOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricStatisticsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricStatisticsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricStreamFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricStreamStatisticsMetricFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricStreamStatisticsConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricStreamOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricWidgetImageInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMetricWidgetImageOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDashboardsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDashboardsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListMetricsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListMetricsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListMetricStreamsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricStreamEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListMetricStreamsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForResourceInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForResourceOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAnomalyDetectorInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutAnomalyDetectorOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutCompositeAlarmInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutDashboardInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutDashboardOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutInsightRuleInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutInsightRuleOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutMetricAlarmInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StatisticSetFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetricDatumFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutMetricDataInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutMetricStreamInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutMetricStreamOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetAlarmStateInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartMetricStreamsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartMetricStreamsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopMetricStreamsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopMetricStreamsOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
